<template>
  <div class="venue-list">
    <ez-table
      :data="venues"
      :columns="columns"
      :columnProps="{
        name: { class: 'cell-name' },
      }"
      :headers="headers"
      :removeButton="canDelete"
      @removeItem="onRemoveItem"
      @rowClick="openVenue">
      <template #cell-name="{ row }">
        <span :title="row.name">{{ row.name }}</span>
      </template>
    </ez-table>
    <ez-button
      v-if="$permission.isPremium"
      type="secondary"
      form-type="button"
      isFullWidth
      @click="addVenue">
      <font-awesome-icon icon="plus"/>
      Add {{ $helpers.remapNaming('venue', 'lower') }}
    </ez-button>
    <venue-modal
      ref="createModal"
      :groupId="groupId"
      :venueId="selectedVenueId"
      @submitSuccess="onCreateFormSubmit" />
    <slot></slot>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import flash from '@/components/ui/FlashMessage';
import EzButton from '@/components/ui/Button';
import EzTable from '@/components/ui/Table';
import VenueModal from '@/views/common/venues/Modal.vue';
import Venue from '@/models/Venue';
import Group from '@/models/Group';

export default {
  components: {
    EzButton,
    EzTable,
    VenueModal,
  },
  props: {
    groupId: {
      type: Number,
      required: true,
    },
    editInModal: {
      type: Boolean,
      default: false,
    },
    venues: {
      type: Array,
      required: true,
    },
    canDelete: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      createFormKey: 'create-venue',
      selectedVenueId: -1,
      headers: {
        name: () => `${this.$helpers.remapNaming('venue')} name`,
        email: () => 'Email address',
        registeredAt: () => 'Date registered',
        status: () => 'Status',
        actions: () => '',
      },
    };
  },
  computed: {
    group() {
      return Group.query()
        .with('venues')
        .find(this.groupId) || { venues: [] };
    },
    isNewVenue() {
      return this.selectedVenueId === -1;
    },
    columns() {
      return [
        'name',
        ...(this.canDelete ? ['actions'] : []),
      ];
    },
  },
  methods: {
    ...mapActions('entities/venues', [
      'fetchVenue',
    ]),
    openModal() {
      this.$refs.createModal.open();
    },
    closeModal() {
      this.$refs.createModal.close();
    },
    onRemoveItem(data) {
      this.$emit('removeItem', data);
    },
    onCreateFormSubmit({ data }) {
      Venue.insert({ data: data.data })
        .then(() => {
          flash.success({
            title: `${this.$helpers.remapNaming('venue')} successfully ${this.isNewVenue ? 'added' : 'updated'}!`,
          });

          this.closeModal();
          this.$emit('venueCreated', data.data);
        });
    },
    addVenue() {
      this.openModal();
      this.selectedVenueId = -1;
    },
    openVenue(row) {
      if (this.editInModal) {
        this.fetchVenue(row.id)
          .then(() => {
            this.selectedVenueId = row.id;
            this.openModal();
          });
      }

      this.$emit('rowClick', row);
    },
  },
};
</script>

<style scoped lang="scss">
  .venue-list {
    .table {
      td.cell-name {
        color: $color-gray-25;
      }
    }

    :deep() .table {
      td {
        height: 56px;
      }
    }

    .button--secondary {
      margin-top: .75rem;
    }
  }
</style>
